/** @jsx jsx */
import { Children, memo } from "react";
import { jsx } from "theme-ui";

var Stack = function Stack(_a) {
  var children = _a.children,
      _b = _a.inline,
      inline = _b === void 0 ? false : _b,
      justifyContent = _a.justifyContent,
      _c = _a.space,
      space = _c === void 0 ? 2 : _c;
  var childrenArray = Children.toArray(children);
  var height = undefined;
  var width = undefined;

  if (justifyContent) {
    if (inline) {
      width = "100%";
    } else {
      height = "100%";
    }
  }

  return jsx("div", {
    sx: {
      display: "flex",
      flexDirection: inline ? "row" : "column",
      flexWrap: "wrap",
      height: height,
      justifyContent: justifyContent,
      width: width
    }
  }, childrenArray.map(function (child, index) {
    if (child === null || child === undefined) {
      return null;
    }

    return jsx("div", {
      key: index,
      sx: inline ? {
        marginRight: space,
        "&:last-of-type": {
          marginRight: 0
        }
      } : {
        marginBottom: space,
        "&:last-of-type": {
          marginBottom: 0
        }
      }
    }, child);
  }));
};

export default memo(Stack);